import SC from "./style";

const TitleCard = (props) => {
  const { data, index } = props;
  return (
    <SC.Card
      whileHover={{ scale: 1.03, y: -3 }}
      whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: 24 }}
      transition={{
        duration: 0.5,
        delay: index * 0.08,
        ease: [0.23, 1, 0.32, 1],
      }}
    >
      <SC.Row>
        <SC.IconWrapper data-icon>{data.icon}</SC.IconWrapper>
        <SC.Content>
          <SC.Title>{data.title}</SC.Title>
          {data.description && (
            <SC.Description>{data.description}</SC.Description>
          )}
        </SC.Content>
      </SC.Row>
    </SC.Card>
  );
};

export default TitleCard;
